import { Component, OnInit, AfterViewInit, ViewChild, Input} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FluidFractionFormComponent } from '../fluid-fraction-form/fluid-fraction-form.component';
import { InjectionFormationsEditorComponent } from '../injection-formations-editor/injection-formations-editor.component';
import { InjectionDataModel } from '../_models/injection-data-model';
import { InjectionDataRecord } from '../_models/injection-data-record';
import { WellDetailsModel } from '../_models/well-details-model';

@Component({
  selector: 'app-other-data-form',
  templateUrl: './other-data-form.component.html',
  styleUrls: ['./other-data-form.component.css']
})
export class OtherDataFormComponent implements OnInit, AfterViewInit {

  @Input() injectionDataModel: InjectionDataModel;
  @Input() well: WellDetailsModel;
  @Input() lastInjection: InjectionDataRecord;

  @ViewChild(FluidFractionFormComponent) fluidFractionForm: FluidFractionFormComponent;
  @ViewChild(InjectionFormationsEditorComponent) injectionFormationsForm: InjectionFormationsEditorComponent;

  public form: FormGroup;

  constructor(
    private formBuilder: FormBuilder
  ) {

  }

  ngOnInit(): void {
    function otherDataValidator() {
      return (group: FormGroup): { [key: string]: any } => {
        var ret: any = {};

        //Make sure that the top and bottom of the injection interval are not reverse.
        if (group.controls.CurrentInjectionIntervalTop != null &&
          group.controls.CurrentInjectionIntervalBottom != null &&
          group.controls.CurrentInjectionIntervalTop.value != null &&
          group.controls.CurrentInjectionIntervalBottom.value != null &&
          group.controls.CurrentInjectionIntervalTop.value > group.controls.CurrentInjectionIntervalBottom.value) {
          ret.injectionIntervalReversed = true;
        }

        if (group.controls.CurrentInjectionIntervalTop != null &&
          group.controls.DepthTubingPacker != null &&
          group.controls.DepthTubingPacker.value > group.controls.CurrentInjectionIntervalTop.value) {
          ret.tubingPackerTooDeep = true;
        }

        return ret;
      }
    }

    this.form = this.formBuilder.group({
      'CurrentInjectionIntervalTop': [this.injectionDataModel.CurrentInjectionIntervalTop],
      'CurrentInjectionIntervalBottom': [this.injectionDataModel.CurrentInjectionIntervalBottom],
      'DepthTubingPacker': [this.injectionDataModel.DepthTubingPacker],
      'InjectedFluidsOtherSources': [this.injectionDataModel.InjectedFluidsOtherSources],
      'InjectionThrough': [this.injectionDataModel.InjectionThrough]
    }, {
      validator: otherDataValidator()
    });
    
  }

  ngAfterViewInit(): void {

    setTimeout(() => {
      this.form.addControl('FluidFractionForm', this.fluidFractionForm.form);
    });

    
    setTimeout(() => {
      this.form.addControl('InjectionFormationsEditor', this.injectionFormationsForm.form);
    });
  }
}
